// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Y6Go","colCheckbox":"styles_colCheckbox__3mJuN"};